module.exports = __webpack_public_path__ + "img/btn-camera.b9d4f788.svg";